const units = {}

const DEFAULT_MONSTER = {
    "health": 25,
    "maxhealth": 30,

    "affiliation": "bad",
    "state": "aggroed",

    "title": "???",
    "subtitle": "Monstrosity",

    "spriteSize": "4x3",
    "weaponImageKey": "hidden",
    "weaponAudioKey": "Unit:Attack:Monster",
}

units["ember/wolf-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wolf-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wolf-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Wolf",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wolf-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/crow-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Crow",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-crow-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bear-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Bear",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-bear-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/stag-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Stag",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-stag-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/leshy-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Leshy",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Staff",
        "element": "earth",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "green-staff",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-hag-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/woodsman-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Woodsman",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-woodsman-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wisp-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wisp-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/wisp-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Wisp",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,
    "power": -10,
    "properties": ["leering"],

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-wisp-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/banshee-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Banshee",
    "skillKeys": [], // not all priests should have restore health by default...
    "state": "idle",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Staff",
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "blue-staff",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-widow-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        },
        "aggroed": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-banshee-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        },
    }
}

units["ember/shepherd-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Shepherd",
    // TODO: should lose sheep after being attacked.

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Staff",
        "element": "fire",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "red-staff"
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd1-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
        // "ember-shepherd1-red": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd1-red.png"),
        // "ember-shepherd2-red": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd2-red.png"),
        // "ember-shepherd3-red": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-shepherd3-red.png"),
    },
}

units["ember/pirate-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Pirate Captain",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-sailor-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/pirate-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Lost Pirate",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-sailor-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/fish-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Fish",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-pike-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/fish-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Dire Fish",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-pike-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/hare-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Hare",

    "health": 10,
    "maxhealth": 10,
    "defense": 0,
    "resistance": 0,
    "moverange": 3,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "ai": {
        "behaviors": [
            "can attack plants",
            "always attacks plants first"
        ]
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-hare-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bull-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Bull",
    // TODO: charging attack!!!

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-bull-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/boglet-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Boglet",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-boglet-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/boglord-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Boglord",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Gun",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "gun",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-boglord-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/kikimora-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Kikimora",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Gun",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "gun",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-kikimora-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/mothman-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Mothman",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "ai": {
        "behaviors": [
            "can attack flames",
            "always attacks flames first"
        ]
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-mothman-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/kelpie-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Kelpie",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": {
            "min": 1,
            "max": 5,
            "orthogonal": true,
            "diagonal": false,
        },
        "power": 20,
        "skillKeys": ["charge"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-kelpie-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/kelpie-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Kelpie",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": {
            "min": 1,
            "max": 5,
            "orthogonal": true,
            "diagonal": false,
        },
        "power": 20,
        "skillKeys": ["charge"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-kelpie-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/rusalka-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Rusalka",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-rusalka-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/bones-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Sunbleached Bones",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-bones-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/blazing-red"] = {
    ...DEFAULT_MONSTER,
    "title": "The Blazing",
    // upon death, spawns an ashwraith in its place

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-blazing-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/ashwraith-red"] = {
    ...DEFAULT_MONSTER,
    "title": "Ash Wraith",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-ashwraith-red.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/jester-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Mournful Jester",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-jester-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/priestess-blue"] = {
    ...DEFAULT_MONSTER,
    "title": "Hollow Priestess",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "skillKeys": ["restore-health"],
    "primaryItem": {
        "name": "Staff",
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "blue-staff",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-priestess-blue.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/knight-green"] = {
    ...DEFAULT_MONSTER,
    "title": "knight-green",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-knight-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/lordandlady-green"] = {
    ...DEFAULT_MONSTER,
    "title": "Lord and Lady",

    "health": 25,
    "maxhealth": 30,
    "defense": 0,
    "resistance": 0,
    "moverange": 0,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "animationKey": "bob",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/monsters/enemy-lordandlady-green.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                {"stack": 210, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
            ]
        }
    },
}

units["ember/incoming/all"] = {
    "spotTag": "incoming",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["inflict-damage"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "imageUrl": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesmulti1.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/Multi 3/blink main/index.js").default},
            ],
        },
    },
}

units["ember/incoming/fire"] = {
    "spotTag": "incoming",
    "name": "Something Bloody",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["inflict-damage"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "imageUrl": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesred.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Red/blink main/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-red.png")},
            ],
        },
    },
}

units["ember/incoming/earth"] = {
    "spotTag": "incoming",
    "name": "Something Rotting",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["inflict-damage"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "imageUrl": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesgreen.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Green/blink main/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-green.png")},
            ],
        },
    },
}

units["ember/incoming/water"] = {
    "spotTag": "incoming",
    "name": "Something Ghastly",
    "jobName": "Lurking in the Dark",
    "affiliation": "nothing",
    "skillKeys": ["inflict-damage"],
    "properties": ["no healthbar"],
    "spriteSize": "4x3",
    "stack": 1000000,
    "maxhealth": 10,

    // "imageUrl": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/sprite-spawner-eyesblue.png"),
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/Mono Blue/blink main/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/enemy-incoming/spawner-glow-blue.png")},
            ],
        },
    },
}

units["ember/torch/1"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/sprite-item-torch1-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 1/Flame/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 1/fireanim-torch1-glow.png")},
            ]
        }
    },
    "data": {
        "flameCount": 1,
    },
}

units["ember/torch/2"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch 2/sprite-item-torch2.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch 2/sprite-item-torch2-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 2/Flame 1/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 2/Glow/fireanim-torch2-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 2/Flame 2/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 2/Glow/fireanim-torch2-glow2.png")},
            ]
        },
    },
    "data": {
        "flameCount": 2,
    },
}

units["ember/torch/3"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch 3/sprite-item-torch3.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch 3/sprite-item-torch3-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 1/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 2/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow2.png")},
            ]
        },
        "flame3": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Flame 3/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 3/Glow/fireanim-torch3-glow3.png")},
            ]
        },
    },
    "data": {
        "flameCount": 3,
    },
}

units["ember/torch/fancy"] = {
    "type": "thing",
    "role":  "torch",
    "title": "Torch",

    "affiliation": "none",

    "maxhealth": 100,
    "isHidingHealthbar": true,

    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch Fancy/sprite-item-torchfancy.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/torch/Torch Fancy/sprite-item-torchfancy-outline.png")},
            ],
        },
        "flame1": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 1/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow1.png")},
            ]
        },
        "flame2": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 2/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow2.png")},
            ]
        },
        "flame3": {
            "parts": [
                {"stack": 10, "animation": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Flame 3/index.js").default},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch Fancy/Glow/fireanim-torchfancy-glow3.png")},
            ]
        },
    },
    "data": {
        "flameCount": 3,
    },
}

units["ember/flame"] = {
    "role": "flame",

    "affiliation": "none",

    "maxhealth": 30,
    "isHidingHealthbar": true,
    "skillKeys": [
        "ember/burnout"
    ],

    "stack": 10,
    "spriteSize": "4x3",
    "sprites": {
        "idle": require("@frog/source/assets/images/ember-tactics/sprites/flame/Torch 1/Flame/index.js").default,
    },

    // "scripts": {
    //     "death": [
    //         "...THE FLAME DIES",
    //     ],
    // }
}

units["ember/plant/blackberry"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Blackberry",
    "subtitle": "Woodland Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-blackberry.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-blackberry-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/ghostturnip"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Ghost Turnip",
    "subtitle": "Woodland Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-turnip.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-turnip-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/kingbolete"] = {
    "type": "thing",
    "role":  "plant",
    "title": "King Bolete",
    "subtitle": "Woodland Fungi",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-kingbolete.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/01 - Woods/sprite-plant-kingbolete-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/lanternonion"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Lantern Onion",
    "subtitle": "Coastal Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-lanternonion.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-lanternonion-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/crookedroot"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Crookedroot",
    "subtitle": "Coastal Root",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-crookedroot.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-crookedroot-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/foxshroom"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Foxshroom",
    "subtitle": "Coastal Fungi",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "protoitem": {
        "name": "Squash",
        "image": require("@frog/source/assets/images/apocalypse-tactics/items/crops/kiwisquash.png"),
    },
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-foxshroom.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/02 - Cliffs/sprite-plant-foxshroom-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/graspgourd"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Graspgourd",
    "subtitle": "Bog Veggie",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-graspergourd.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-graspergourd-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/phantomring"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Phantom Ring",
    "subtitle": "Bog Mushroom",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-phantomring.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-phantomring-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/cravenberry"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Cravenberry",
    "subtitle": "Bog Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-cravenberry.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/03 - Swamp/sprite-plant-cravenberry-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/castlemaiden"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Castle Maiden",
    "subtitle": "Ashland Berry",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-castlemaiden.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-castlemaiden-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/crescentvine"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Crescent Vine",
    "subtitle": "Ashland Veggie",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-crescentvine.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-crescentvine-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

units["ember/plant/inkcap"] = {
    "type": "thing",
    "role":  "plant",
    "title": "Inkcap",
    "subtitle": "Ashland Mushroom",
    "affiliation": "none",
    "health": 10,
    "maxhealth": 10,
    "isHidingHealthbar": true,
    "spriteSize": "4x3",
    "sprites": {
        "idle": {
            "parts": [
                {"stack": 10, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-inkcap.png")},
                {"stack": 110, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/04 - Ashlands/sprite-plant-inkcap-outline.png")},
                {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/plants/sprite-plantshadow.png")},
            ],
        }
    },
}

export default units
